import React from 'react';
import { ShieldCheck, ArrowRight } from 'lucide-react';
import { useLoginPage } from '../hooks/useLoginPage';

export const LoginPage: React.FC = () => {
  const { error, handleLogin } = useLoginPage();

  return (
    <div className="flex min-h-[calc(100vh-3.5rem)] items-center justify-center p-4 bg-paper-50 dark:bg-study-slate">
      <div className="w-full max-w-md rounded-lg border border-paper-300 bg-paper-100 p-8 shadow-sm dark:border-study-line dark:bg-study-panel">
        <div className="mb-6 border-b border-paper-200 pb-4 dark:border-study-line">
          <div className="flex items-center gap-2">
            <span className="font-serif text-xl font-bold tracking-tight text-zinc-900 dark:text-zinc-100">
              Portal Do Vestibulando
            </span>
            <span className="font-serif text-xl font-light text-paper-500 dark:text-zinc-400">
              2027
            </span>
          </div>
          <p className="mt-1 text-xs text-zinc-600 dark:text-zinc-400">
            Ambiente de Triagem — IFF Campos Centro
          </p>
        </div>

        {error && (
          <div className="mb-4 rounded border border-red-300 bg-red-50 p-3 text-xs text-red-700 dark:border-red-900/50 dark:bg-red-950/30 dark:text-red-300">
            Falha na autenticação via Discord ({error}). Tente novamente.
          </div>
        )}

        <div className="space-y-4 text-xs text-zinc-700 dark:text-zinc-300">
          <div className="flex items-start gap-2.5 rounded border border-paper-200 bg-paper-50 p-3 dark:border-study-line dark:bg-study-card">
            <ShieldCheck className="h-4 w-4 shrink-0 text-emerald-600 dark:text-emerald-400 mt-0.5" />
            <div>
              <p className="font-semibold text-zinc-900 dark:text-zinc-100">Acesso Restrito ao Candidato</p>
            </div>
          </div>
        </div>

        <button
          type="button"
          onClick={handleLogin}
          className="mt-6 flex w-full items-center justify-center gap-2.5 rounded bg-[#5865F2] px-4 py-2.5 text-xs font-semibold uppercase tracking-wider text-white shadow transition-all hover:bg-[#4752C4] active:scale-[0.99]"
        >
          <svg className="h-4 w-4 fill-current" viewBox="0 0 24 24">
            <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.929 1.793 8.18 1.793 12.061 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.893.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.028zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
          </svg>
          Entrar com Discord
          <ArrowRight className="h-4 w-4 ml-auto" />
        </button>
      </div>
    </div>
  );
};
